/* tslint:disable */
/* eslint-disable */
/**
 * Xpanse Portal BFF Service API
 * Rest API for Xpanse Portal
 *
 * The version of the OpenAPI document: @project.version@
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthDiscoveryResult,
} from '../models/index';
import {
    AuthDiscoveryResultFromJSON,
    AuthDiscoveryResultToJSON,
} from '../models/index';

export interface DiscoverAuthenticationSettingsRequest {
    email: string;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     * Discovers available authentication methods and settings for a user identity based on their email address. This endpoint returns configuration details for different authentication types including Cognito settings, tenant information, and authorization endpoints. The API supports embedded login, managed login, and SSO authentication flows.
     * Discover Authentication Settings for a given identity
     */
    async discoverAuthenticationSettingsRaw(requestParameters: DiscoverAuthenticationSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AuthDiscoveryResult>>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling discoverAuthenticationSettings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/discovery`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AuthDiscoveryResultFromJSON));
    }

    /**
     * Discovers available authentication methods and settings for a user identity based on their email address. This endpoint returns configuration details for different authentication types including Cognito settings, tenant information, and authorization endpoints. The API supports embedded login, managed login, and SSO authentication flows.
     * Discover Authentication Settings for a given identity
     */
    async discoverAuthenticationSettings(requestParameters: DiscoverAuthenticationSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AuthDiscoveryResult>> {
        const response = await this.discoverAuthenticationSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
